import { Nullable } from '../datatypes/misc';
import { PhoneNumbers } from './phone-numbers.model';

export class Candidate  {

    public HasCv: boolean;
    public OutsideUkAndEeaConsentGiven: Nullable<boolean>;
    public EmailConfirm: string;
    public isSkillsAdded = false;
    public isJobPreferenceAdded = false;
    public isRefereeAdded = false;
    EmailBlocked: boolean



    constructor(
        public Email: string,
        public Password: string,
        public PasswordConfirm: string,
        public Title: Nullable<string>,         
        public FirstName: string,     // required
        public MiddleName: string,
        public LastName: string,      // required
        public Phone: PhoneNumbers[], // required
        public Address: CandidateAddress,
        public Personal: CandidatePersonal,
        public Referee: Referee[],
        public Compliance: CandidateCompliance,
        public JobPreferences: CandidateJobPreferences,
        public AcceptanceOfTermsAndConditions: CandidateAcceptanceOfTermsAndConditions,
        public CommunicationsPreference: CommunicationsPreference[],
        public SysUser: string
    ) { }

    // having to create a static copy method here, else the functions that exist on Candidate will not exist on the
    // newly instantiated object if we just make an assignment from the callback.
    public static Copy(input: Candidate): Candidate {
        const result = new Candidate(input.Email, input.Password, input.PasswordConfirm, input.Title, input.FirstName,
            input.MiddleName, input.LastName, input.Phone, input.Address, input.Personal,
            input.Referee, input.Compliance, input.JobPreferences, input.AcceptanceOfTermsAndConditions,
            input.CommunicationsPreference, input.SysUser);
        result.HasCv = input.HasCv;
        return result;
    }
}

export class CandidateAddress {
    constructor(
        public Street1: string,    // required
        public Street2: string,
        public City: string,            // required
        public County: string,
        public Country: string,         // required
        public Postcode: string         // required
    ) { }

    static createDefault(): CandidateAddress {
        return new CandidateAddress('', '', '', '', '', '');
    }
}

export class CandidateJobPreferences {

    private CandidateJobPreferencesDefaultCompleteness = 20;

    constructor(
        public Contract: string,                // e.g. {Permanent, FixedTerm, Temporary, Apprenticeship}
        public Hours: string,                   // e.g. {FullTime,PartTime} config
        public AvailabilityToWork: string,      // e.g. { Immediately, EndOfCourse }
        public Sectors: string,                  // e.g. {xxx,yyy,zzz}
        public SalaryExpectations: string
    ) { }

    static createDefault(): CandidateJobPreferences {
        return new CandidateJobPreferences('', '', '', '', null);
    }
}

export class CandidatePersonal {
    constructor(
        public Nationality: string,
        public DateOfBirth: string,
        public DrivingLicence: Nullable<boolean>,
        public OwnTransport: Nullable<boolean>,
        public CleanLicense: Nullable<boolean>,        
        public Skills: string,
        public Qualifications: string,
        public CurrentEmployer: string,
        public CurrentJobTitle: string,
        public NoticePeriod: string
    ) { }

    public IsCurrentlyStudying: boolean | null = null;
    public CurrentlyStudyingAt: string;
    public Course: string;
    public CourseStartDate: Date;
    public CourseEndDate: Date;

    static createDefault(): CandidatePersonal {
        return new CandidatePersonal('', null, null, null, null, '', '', '', '', null);
    }
}

export class CandidateCompliance {
    constructor(
        public EligibilityToWorkInUKDate: string,
        public EligibilityToWorkInUK: Nullable<boolean>,
        public VisaType: string,
        public VisaExpiry: string
    ) { }

    static createDefault(): CandidateCompliance {
        return new CandidateCompliance(null, false, '', null);
    }
}

export class CandidateAcceptanceOfTermsAndConditions {
    constructor(
        public AcceptanceOfTermsAndConditions: boolean,
        public Date: string
    ) { }

    static createDefault(): CandidateAcceptanceOfTermsAndConditions {
        return new CandidateAcceptanceOfTermsAndConditions(false, null);
    }
}

export class Referee {

    constructor(
        public Name: string,
        public OrganisationName: string,
        public JobTitle: string,
        public Email: string,
        public Phone: string,
        public ReferenceType: string,
        public ContactOptionId: number,
        public ToBeDeleted: boolean
    ) { }

    static createDefault(): Referee {
        return new Referee('', '', '', '', '', '', null, false);
    }

    static TrimWhitespaces(referee: Referee) {
        referee.Name = referee.Name.trim();
        referee.OrganisationName = referee.OrganisationName.trim();
        referee.JobTitle = referee.JobTitle.trim();
        referee.Email = referee.Email.trim();
        referee.Phone = referee.Phone.trim();
    }
}

export class CommunicationsPreference {
    constructor(
        public Category: string,
        public Method: CommunicationsMethodDto[]
    ) { }

    static createDefault(): CommunicationsPreference {
        return new CommunicationsPreference('', []);
    }
}

export class CommunicationsMethodDto {
    constructor(
        public Name: string,
        public Consent: boolean,
        public ConsentDate: string) { }
}


export class CandidateTermsAndConditionsConsent {

    public readonly Success: boolean;
    public readonly CandidateGuid: string;
    public ConsentForAllJobs: boolean;
    public initialValueConsentForAllJobs: boolean;

    public readonly initialValueOutsideUkEeaConsentGiven: boolean;


    constructor(
        public Email: string,
        public OutsideUkEeaConsentGiven: boolean
    ) {

        this.initialValueOutsideUkEeaConsentGiven = OutsideUkEeaConsentGiven;
    }
}

export class ConsentDetails {

    public readonly OutsideUkEeaConsentRequired: boolean;
    public readonly OutsideUkEeaConsentPeriod: string;
}
